/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { THEMES, menuBtnStyle } from "../utils/theme1Constants";
import { buildImageUrl, publicStoreText } from "../utils/theme1Helpers";

export default function StoreHeader({
  storeData,
  theme,
  allowThemeChange,
  selectedTheme,
  setSelectedTheme,
  isMobile,
  customer,
  showAccountMenu,
  setShowAccountMenu,
  loadCustomerOrders,
  setShowOrdersModal,
  handleLogout,
  setShowAuthModal,
  cart,
  setShowCartSidebar,
  searchQuery,
  setSearchQuery,
}) {

  return (
    <header style={{
      background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
      padding: isMobile ? "12px 0" : "20px 0",
      boxShadow: `0 4px 20px ${theme.primary}33`,
      position: "sticky",
      top: 0,
      zIndex: 1000
    }}>
      <div style={{ maxWidth: "1400px", margin: "0 auto", padding: isMobile ? "0 15px" : "0 20px" }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr auto" : "auto minmax(200px, 1fr) auto",
          gridTemplateRows: isMobile ? "auto auto" : "auto",
          columnGap: "16px",
          rowGap: isMobile ? "12px" : "0",
          alignItems: "center",
          direction: "rtl",
          width: "100%"
        }}>



          {/* Logo & Store Name */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            gridColumn: isMobile ? "1 / 2" : "auto",
            gridRow: isMobile ? "1" : "auto"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0
            }}>
              <img src={buildImageUrl(storeData.logo)} alt="Logo" style={{ width: isMobile ? "45px" : "55px", height: isMobile ? "45px" : "55px", objectFit: "contain" }} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px", minWidth: 0 }}>
              <h1 style={{ margin: 0, color: "white", fontSize: isMobile ? "18px" : "24px", fontWeight: "700", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {storeData.storeName}
              </h1>
              {publicStoreText(storeData.storeSlogan, storeData.description, storeData.sectorType) && (
                <p style={{ margin: 0, color: "rgba(255,255,255,0.9)", fontSize: isMobile ? "10px" : "12px", display: isMobile ? "none" : "block" }}>
                  {publicStoreText(storeData.storeSlogan, storeData.description, storeData.sectorType)}
                </p>
              )}
            </div>
          </div>

          {/* Search Bar - Modern Design */}
          <div style={{
            maxWidth: isMobile ? "100%" : "600px",
            width: "100%",
            minWidth: "0",
            position: "relative",
            justifySelf: "center",
            gridColumn: isMobile ? "1 / 3" : "auto",
            gridRow: isMobile ? "2" : "auto"
          }}>


            <div style={{
              display: "flex",
              alignItems: "center",
              background: "white",
              borderRadius: "50px",
              padding: isMobile ? "8px 15px" : "10px 20px",
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
            }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: "10px", opacity: 0.5, flexShrink: 0 }}>
                <path d="M19 19L13 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke={theme.primary} strokeWidth="2" strokeLinecap="round" />
              </svg>
              <input
                type="text"
                placeholder="ابحث عن المنتجات، العلامات التجارية، الفئات..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  border: "none",
                  outline: "none",
                  flex: 1,
                  fontSize: "14px",
                  color: "#333",
                  minWidth: 0,
                }}
              />


              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "5px",
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 0
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L4 12M4 4L12 12" stroke="#999" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/* Header Actions */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "flex-end",
            gridColumn: isMobile ? "2 / 3" : "auto",
            gridRow: isMobile ? "1" : "auto"
          }}>

            {/* Theme Selector */}
            <div style={{ position: "relative", display: isMobile ? "none" : "block" }}>
              {allowThemeChange && (
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    background: "rgba(255,255,255,0.2)",
                    padding: "5px",
                    borderRadius: "25px",
                    border: "1px solid rgba(255,255,255,0.3)",
                  }}
                >
                  {[1, 2, 3, 4].map((themeNum) => (
                    <button
                      key={themeNum}
                      onClick={() => setSelectedTheme(themeNum)}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        border: "none",
                        background:
                          selectedTheme === themeNum
                            ? "white"
                            : THEMES[themeNum].primary,
                        cursor: "pointer",
                        transition: "all 0.3s",
                        boxShadow:
                          selectedTheme === themeNum
                            ? "0 2px 8px rgba(0,0,0,0.2)"
                            : "none",
                      }}
                      title={THEMES[themeNum].name}
                    />
                  ))}
                </div>
              )}
            </div>


            {customer ? (
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <button
                  onClick={() => setShowAccountMenu(v => !v)}
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    border: "1px solid rgba(255,255,255,0.3)",
                    color: "white",
                    padding: isMobile ? "8px 10px" : "10px 20px",
                    borderRadius: "25px",
                    cursor: "pointer",
                    fontSize: isMobile ? "12px" : "14px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}
                >
                  {customer.name || customer.customerName}
                </button>

                {showAccountMenu && (
                  <div style={{
                    position: "absolute",
                    top: "55px",
                    background: "white",
                    color: "#333",
                    borderRadius: "12px",
                    boxShadow: "0 10px 30px rgba(0,0,0,.2)",
                    padding: "10px",
                    zIndex: 9999,
                    minWidth: "160px"
                  }}>
                    <button
                      onClick={() => {
                        loadCustomerOrders();
                        setShowOrdersModal(true);
                        setShowAccountMenu(false);
                      }}
                      style={menuBtnStyle}
                    >
                      طلباتي
                    </button>

                    <button
                      onClick={() => {
                        handleLogout();
                        setShowAccountMenu(false);
                      }}
                      style={menuBtnStyle}
                    >
                      تسجيل الخروج
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button
                onClick={() => setShowAuthModal(true)}
                style={{
                  background: "rgba(255,255,255,0.2)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  color: "white",
                  padding: isMobile ? "8px 10px" : "10px 20px",
                  borderRadius: "25px",
                  cursor: "pointer",
                  fontSize: isMobile ? "12px" : "14px",
                  fontWeight: "600"
                }}
              >
                {isMobile ? "دخول" : "تسجيل دخول"}
              </button>
            )}

            {/* Cart Button with Badge */}
            <button
              onClick={() => setShowCartSidebar(true)}
              style={{
                position: "relative",
                background: "white",
                border: "none",
                width: isMobile ? "42px" : "50px",
                height: isMobile ? "42px" : "50px",
                borderRadius: "50%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
                transition: "transform 0.2s",
                flexShrink: 0
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z" fill={theme.primary} />
                <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z" fill={theme.primary} />
                <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19C19.5304 16 20.0391 15.7893 20.4142 15.4142C20.7893 15.0391 21 14.5304 21 14V6H7M7 6L5 2H1" stroke={theme.primary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              {cart.length > 0 && (
                <span style={{
                  position: "absolute",
                  top: "-5px",
                  right: "-5px",
                  background: "#E74C3C",
                  color: "white",
                  borderRadius: "50%",
                  width: "22px",
                  height: "22px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "11px",
                  fontWeight: "700"
                }}>
                  {cart.reduce((sum, item) => sum + (item.quantity || item.qty || 0), 0)}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
